import * as React from "react";

function SvgLightBlueCircle(props) {
  return (
    <svg viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx={400} cy={400} r={400} fill="#36A9E1" />
    </svg>
  );
}

export default SvgLightBlueCircle;
